export default "__VITE_ASSET__Dj5L8cq0__"